import React, {
    PropTypes,
} from 'react';
import {Table} from 'react-bootstrap';
import {connect} from 'react-redux';
import axios from 'axios';
import {apibase} from '../../api/api';

class FinanceDetails extends React.Component {
    static propTypes = {
        fio: PropTypes.string.isRequired,
        classnum: PropTypes.number,
        date: PropTypes.string.isRequired,
        details: PropTypes.array.isRequired,
        invoices: PropTypes.array.isRequired,
        type: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    };

    render() {
        const {fio, classnum, date, details, invoices, type, id} = this.props;
        const token = axios.defaults.headers.common['Authorization'];
        if (details.length === 0) {
            return (<div></div>);
        }
        const rows = details.map((detail) => {
            return <tbody>
            <tr style={{background: "#e2e2e2", textAlign: "center"}}>
                <td colSpan={2}>
                    <strong>{detail.salesDirectionName}</strong></td>
            </tr>
            <tr>
                <td><strong>Заборгованість/залишок на 1 число розрахункового місяця</strong></td>
                <td><strong>{detail.balance}</strong></td>
            </tr>
            {detail.sales.map((sale) => {
                return <tr>
                    <td>{sale.waresName}</td>
                    <td>{sale.total}</td>
                </tr>
            })}
            <tr>
                <td><strong>Всього до сплати</strong></td>
                <td><strong>{detail.total}</strong></td>
            </tr>
            </tbody>
        });
        return (
            <div>
                <Table condensed className="mt15 my-table">
                    <tbody>
                    <tr>
                        <td><strong>ПІБ учня</strong></td>
                        <td>{fio}</td>
                    </tr>
                    <tr>
                        <td><strong>На дату</strong></td>
                        <td>{date}</td>
                    </tr>
                    <tr>
                        <td><strong>Клас</strong></td>
                        <td>{classnum}</td>
                    </tr>
                    </tbody>
                </Table>
                <Table condensed className="mt15 my-table">
                    {rows}
                </Table>
                {invoices.map((invoice) => {
                    return <div>
                        <a href={apibase + '/v1/fin/get_invoice?object_type=' + type + '&object_id=' + id + '&sales_direction_id=' +
                        invoice.salesDirectionId + '&account_id=' + invoice.accountId + '&Authorization=' + token}
                           className="btn btn-default btn-block"
                           style={{whiteSpace: "normal"}}
                           target="_blank"
                        >
                            <span className="fa fa-print"></span> &nbsp;
                            Друк квитанції за {invoice.salesDirectionName} (рахунок {invoice.accountNum})
                        </a>
                    </div>
                })}
            </div>
        );
    };
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps, {})(FinanceDetails);




/** WEBPACK FOOTER **
 ** ./src/modules/finance/FinanceDetails.js
 **/